export default "__VITE_ASSET__CE6zkk8z__"